import { render } from "./PostOutline.vue?vue&type=template&id=c53cdc1c&ts=true"
import script from "./PostOutline.vue?vue&type=script&lang=ts"
export * from "./PostOutline.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__